import { render } from "./SiteLink.vue?vue&type=template&id=01e80800&scoped=true"
import script from "./SiteLink.vue?vue&type=script&lang=js"
export * from "./SiteLink.vue?vue&type=script&lang=js"

import "./SiteLink.vue?vue&type=style&index=0&id=01e80800&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01e80800"

export default script